// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1KXh6","bigColWidth":"Table_bigColWidth__w4hiI","biggerColWidth":"Table_biggerColWidth__ppZmU","row":"Table_row__TfaNq","col":"Table_col__2z7mI"};